import { Component, OnInit } from '@angular/core';


import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
const swal = require('sweetalert');
import { BusinessInfoService } from '../../POSServices/Business/business-info.service';
import { environment } from '../../../../environments/environment';
import { Category } from '../../models/category';
import { FooterComponent } from 'src/app/layout/footer/footer.component';
import { ItemServiceService } from '../../POSServices/Setup/item-service.service';
import * as uuid from "uuid";
const _clone = (d) => JSON.parse(JSON.stringify(d));

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

  shippingZipCodeError:any;
  removecoupons:boolean=false;
  DAmount=0;
  TBill=0;
  discAmount:boolean=false;
  couponcode:boolean=false;
  Applycouponscode:boolean=false;
  Totalcost:any;
  invalidcouponmsg:boolean=false;
  btncoupon:boolean=true;
  discountAmount:any;
  Ccode= new FormControl("", [Validators.required]);
  orderdetailsid=0;
  itemslistdetails=[];
  categorieslist:any;
  listofcategory:any;
  listofitems:any;
  
//   public states: Array<string> = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
//   'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa',
//   'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Orissa', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
//   'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
// ];
public states: Array<string> = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
'Haryana','Himachal Pradesh','Jammu and Kashmir','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur',
'Meghalaya', 'Mizoram','Nagaland','Odisha','Punjab','Rajasthan', 'Sikkim','Tamil Nadu','Telangana','Tripura', 'Uttar Pradesh',
'Uttarakhand','West Bengal','Andaman and Nicobar','Chandigarh','Dadra and Nagar Haveli','Daman and Diu','Delhi','Lakshadweep',
'Pondicherry',
];
public CountryList: Array<string> = ['India'];

  // edit order list
  city:any;
state:any
country:any
  updateorderid:any;
  editorderlist=[];
  taxrate:any
  newcustomercreate:boolean=false
  Customermail:any;
  removeitemslist=[];
  invalidamount:boolean=false;
  merchantdata: UserPOSData ;
  contactrefrence = [
    { text: "Email", value: "Email" },
    { text: "Text Message", value: "Text Message" },
    { text: "Phone Call", value: "Phone Call" },
    { text: "All", value: "All" },

  ];
  OrderID:any;
  keyVal:any;
  paymenttype:any;
  SendEmail:boolean=false;
  oid;
  cashpay:boolean=false;
  rtnamount;
  mail= new FormControl("", [Validators.required]);
  tenderamount= new FormControl("", [Validators.required]);
  returAmount= new FormControl("", [Validators.required]);
  show:any;
  itemsdata=[];
  editing = {};
  categories = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  // temp = [];
  expanded: any = {};
  timeout: any;

  rowsSel = [];
  selected = [];
  private fieldArray: Array<any> = [];
  private newAttribute: any = {};
  //  myItems: order[] = new Array();

  myItems=[];
  orderdetailslist=[]
  taxfeelist=[];

// @ViewChild(MatPaginator) paginator: MatPaginator;
// @ViewChild(MatSort) sort: MatSort;
categoryid:any;
itemslist:boolean=false;
  isemployee: boolean = false;
  address: boolean = false;
  isNewOrder: boolean = true;
  isUpdateOrder: boolean = false;
  categoryItems = [];
  temp = [];
  orderId = new FormControl("", [Validators.required]);
 id= new FormControl("", [Validators.required]);
 OrderId = new FormControl("", [Validators.required]);
 TenderType  =new FormControl("", [Validators.required]);
 LineItemCount  = new FormControl("", [Validators.required]);
 LineItemTotalAmount  =new FormControl("", [Validators.required]);
//  TaxAmount  = new FormControl("", [Validators.required]);
TaxAmount  :any
 ShippingAmount  = new FormControl("", [Validators.required]);
 AdditionalCharge  = new FormControl("", [Validators.required]);
 TipAmount  = new FormControl("", [Validators.required]);
 DiscountAmount  = new FormControl("", [Validators.required]);
 TotalNetAmount  = new FormControl("", [Validators.required]);
 OrderSource  = new FormControl("", [Validators.required]);
 OrderStatus  = new FormControl("", [Validators.required]);
 PaymentId  = new FormControl("", [Validators.required]);
 ItemDescription= new FormControl("", [Validators.required]);
 OrderDetails= new FormControl("", [Validators.required]);
 ItemCategory= new FormControl("", [Validators.required]);
  Quantity= new FormControl("", [Validators.required]);
 ItemPrice= new FormControl("", [Validators.required]);
 TaxType= new FormControl("", [Validators.required]);
 DisCountAmount= new FormControl("", [Validators.required]);
 DisCountType= new FormControl("", [Validators.required]);
 ItemId= new FormControl("", [Validators.required]);
 TotalNetItemAmount= new FormControl("", [Validators.required]);
 FirstName= new FormControl("", [Validators.required]);
 LastName= new FormControl("", [Validators.required]);
 Phonenumber= new FormControl("", [Validators.required]);
 isBillingaddress: boolean = false;
 shippingaddress:boolean = false;
 isShipping:boolean = false;
 billingaddressdeatil:any;
 cid:any;
 cname: any;
 cmobileno: any;
 cemail: any;
 cAddress: any;
 cBirthDay: any;
 cNotes: any;
 cContactPerference: any;
 Price:any;
 ItemName:any;
 Amount:any;
quantity:any;
Bill:number=0;
Bills=new FormControl("", [Validators.required]);
BCity = new FormControl("", [Validators.required]);
BState = new FormControl("", [Validators.required]);
CustomerDetails:any;
customerdetails:any;
Tax= new FormControl("", []);
Shipping:any;

Description= new FormControl("", [Validators.required]);


// latest saving using fields
PosSubscriptionId= new FormControl("", [Validators.required]);
CustomerID = new FormControl("", []);
CustomerName = new FormControl("", []);
Email= new FormControl("", []);
MobileNo = new FormControl("", [Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
Address  = new FormControl("", []);
BirthDay = new FormControl("", []);
Notes = new FormControl("", []);
ContactPerference  = new FormControl("", []);
//shippinf details
Address1= new FormControl("", []);
Address2= new FormControl("", []);
City= new FormControl("", []);
State= new FormControl("", []);
ZipCode= new FormControl("", []);
Country= new FormControl("", []);
ShippingEmail= new FormControl("", []);
MobileNumber= new FormControl("", [Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);

SAddress1= new FormControl("", []);
SAddress2= new FormControl("", []);
SCity= new FormControl("", []);
SState= new FormControl("", []);
SZipCode= new FormControl("", []);
SCountry= new FormControl("", []);
SShippingEmail= new FormControl("", []);
SMobileNumber= new FormControl("", []);



isoderdetails: boolean = false;
isbillcalculate: boolean = false;

 CategoryClass: string;
//  columns: ListColumn[] = [
//   { name: 'Name', property: 'ItemCategory', visible: true, isModelProperty: true },
//   { name: 'Price', property: 'ItemPrice', visible: true, isModelProperty: true },
//   { name: 'Actions', property: 'actions', visible: true }, 
// ] as ListColumn[];

AlldataSource;
PaidInvoicedataSource;
slist:any;
currency:any;
  constructor( private router: Router,
    private service: ItemServiceService,
    private activatedRoute: ActivatedRoute,
    private businessinfo:BusinessInfoService,
    //private dialog: MatDialog,
    
    private commonfunction: CommonFunctionService) { 
      this.getGetcategorytaxfeeDetails();
      this.editorderdetails();
      this.slist = this.commonfunction.getStatesList();
      this.currency = this.commonfunction.GetCurrencysymbol();
//category details

this.GetitemcategoryList((data) => {
  
});
    }

    Getitemdetails(cb) {
      let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      const req = new XMLHttpRequest();
      this.service.GetItemListUrl(merchantdata.PosSubscriptionId).subscribe(data => {  
      if(data !=null)
      {
        this.temp = _clone(data);
        this.itemslistdetails= _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
        for(let i=0;i<this.categorieslist.length;i++)
        { 
          for(let j=0;j<this.itemslistdetails.length;j++)
          { 
            // var a=this.categorieslist[i].id;
            // var b=this.itemslistdetails[j].categoryId;
          if(this.categorieslist[i].Id==this.itemslistdetails[j].CategoryId)
          {
    
            let categoryName=this.categorieslist[i].CategoryName;
            let id=this.categorieslist[i].Id;
            let taxType=this.categorieslist[i].TaxType;
            this.newAttribute = {categoryName,id,taxType};   
            this.categories.push(this.newAttribute); 
             j=this.itemslistdetails.length+1;
          }
    
        }
        }
        if(this.categories.length != 0)
        {
          this.dipalyitems(this.categories[0].id);
        }
      }
    });
      // req.open('GET',environment.GetItemListUrl+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
      // req.onload = () => {
      //     cb(JSON.parse(req.response));
      // };
    
      // req.send();
    }
  
  
//category

GetitemcategoryList(cb) {
  let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
  const req = new XMLHttpRequest();
  this.service.GetItemCategoryListUrl(merchantdata.PosSubscriptionId).subscribe(data => {   
  if(data !=null)
  {
    this.temp = _clone(data);
    this.categorieslist = _clone(data);;
    this.rowsFilter = _clone(data);;
    this.rowsExp = _clone(data);
    this.rowsSort = _clone(data);
    this.rowsSel = _clone(data);
    this.Getitemdetails((data) => {
      // cache our list
    
    });
  }
});
  // req.open('GET',environment.GetItemCategoryListUrl+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
  // req.onload = () => {
  //     cb(JSON.parse(req.response));
     
  // };

  // req.send();

}
  ngOnInit() {
      
  }


  openConfirmationDialog() {
    swal({
      title: 'Are you sure you want Cancel Order',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel!',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes!',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
   
       this.ordercancelation();
      } else {
        window.location.reload();
        // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  ordercancelation()
  {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",OrderId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.OrderId=params["orderid"];
      this.updateorderid=params["orderid"];
      form.merchantKeyId = params["merchantKeyId"];
      let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      form.PosSubscriptionId  = merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.orderidcancelation(form).subscribe(result => { 
      if(result !=null)
      {
        this.router.navigate(["/pos"]);
      }
    });

  }


  editorderdetails()
  {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",OrderId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["orderid"];
      this.orderdetailsid= params["id"];
      form.OrderId=params["orderid"];
      this.updateorderid=params["orderid"];
      form.merchantKeyId = params["merchantKeyId"];
      let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      form.PosSubscriptionId  = merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetOrderdetails(form).subscribe(result => { 
      if(result !=null)
      {
        this.Bill=0;
        // this.editorderlist= _clone(result.orderDetails);
       for(let i=0;i<result.length;i++)
       { 

     var ItemName=result[i].ItemName;
     var ItemCategory=result[i].ItemCategory;
     var ItemPrice=result[i].ItemPrice;
     var Quantity=result[i].Quantity;
     var Amount=ItemPrice * Quantity;
     var Id=result[i].Id;
     var ItemId=result[i].ItemId;
     var ItemDescription=result[i].ItemDescription;
     var TaxAmount=result[i].ItemTaxAmount;
      //Amount= Amount + TaxAmount;
      Amount=TaxAmount+Amount;
    // Amount= Amount + Amountcal;
      var DisCountAmount=result[i].DiscountAmount;
         this.newAttribute = {ItemName,ItemPrice,Amount,Quantity,Id,ItemId,ItemDescription,TaxAmount,ItemCategory,DisCountAmount}; 
         this.myItems.push(this.newAttribute); 
         this.Bill=this.Bill+Amount;
         if(this.DAmount==0)
         {
          this.DAmount=this.DAmount+result[0].DiscountAmount;
         }
      
         this.isbillcalculate=true;
         this.couponcode=true;
         this.Applycouponscode=true;


        // this.myItems[i].ItemDescription=this.editorderlist[i].itemDescription;


        

       }
      
      // this.Bill= this.Bill-this.DAmount;
       this.Bill= this.Bill;
       if(this.DAmount>0)
       {
         this.discountAmount=this.DAmount
         this.discAmount=true;
         this.TBill= this.Bill-this.DAmount;
         this.Totalcost=this.TBill;
         this.Applycouponscode=false;
         this.removecoupons=true;
       }
      
      } 
    }); 
  }

  getGetcategorytaxfeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      form.PosSubscriptionId  = merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetCategoryTaxFeeList(form).subscribe(result => {  
      this.taxfeelist = result;
   
      console.log("result.Id---" + result);
     
    });
 
  }


    dipalyitems(id)
    {
      this.CategoryClass="ActiveCategoryClass";
      this.categoryid=id;
    
      this.GetcatedoryidList((data) => {
      // cache our list
     
  
  });
  
  }
  GetcatedoryidList(cb) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    this.service.GetcatedoryidList(merchantdata.PosSubscriptionId,this.categoryid).subscribe(data => {   
    if(data !=null)
    {
      this.temp = _clone(data);
      this.categoryItems = _clone(data);
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
      if(this.categoryItems.length>0)
      {
        this.itemslist=true;
      }
      else{
        this.itemslist=false;
      }
    }
  });
    // const req = new XMLHttpRequest();
    // req.open('GET',environment.GetcatedoryidList+"?posSubscriptionId="+merchantdata.PosSubscriptionId+"&categoryid="+this.categoryid);
  
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    //  };
  
    // req.send();
  }
  // else{
  // this.categoryItems  = JSON.parse(localStorage.getItem('categoryitemslist'));
  // if(this.categoryItems.length>0)
  // {
  //   this.itemslist=true;
  // }
  // else{
  //   this.itemslist=false;
  // }
  // }
// }

   
  addcart(Id,ItemName,ItemPrice,description,cid)
  {
   
    
for(let i=0;i<this.categories.length;i++)
{ 
 
  if(this.categories[i].id==cid)
  {
    var ItemCategory=this.categories[i].categoryName;
    for(let j=0;j<this.taxfeelist.length;j++)
    {
      if(this.taxfeelist[j].TaxFeeName==this.categories[i].taxType)
      {
        this.TaxAmount=this.taxfeelist[j].TaxRate;
      
      }
    }
   
   
  }
}

    this.isoderdetails=true;
    this.isbillcalculate=true;
    this.Applycouponscode=true;
    this.couponcode=true;
  var isExists =0;
  if(this.myItems.length!=0) 
       { 
       
         for (var j= 0; j <this.myItems.length; j++)  
       { 
         
          if(this.myItems[j].ItemName==ItemName)
            { 

              this.Price=ItemPrice;  
              let Quantity=1;          
              var taxAmt =this.TaxAmount;  
              //  let TaxRate=taxAmt;
               this.Amount=ItemPrice * 1;       
              let Amount=this.Amount * Quantity;
            var itemprice=Amount*Quantity*taxAmt/100



              var tax =this.myItems[j].TaxAmount ;  
              let TaxRate=tax;
              isExists =1;
               let qty=this.myItems[j].Quantity;
               this.myItems[j].Quantity=qty+1;
              let amt=this.myItems[j].ItemPrice*1*TaxRate/100;
              this.myItems[j].TaxAmount=itemprice+this.myItems[j].TaxAmount
           this.Bill =this.Bill+this.myItems[j].ItemPrice+itemprice;
              this.myItems[j].Amount=itemprice+ItemPrice +this.myItems[j].Amount;
              this.myItems[j].TotalNetItemAmount=  this.myItems[j].TotalNetItemAmount+this.myItems[j].ItemPrice+itemprice;



              this.myItems[j].TotalNetItemAmount= Math.round(this.myItems[j].TotalNetItemAmount * 100) / 100;
              this.myItems[j].TaxAmount= Math.round(this.myItems[j].TaxAmount * 100) / 100;
              this.Bill=Math.round( this.Bill * 100) / 100;
            }
           
        }
      }
  if(isExists != 1)
  {       
             this.Price=ItemPrice;  
              let Quantity=1;          
              var tax =this.TaxAmount;  
              let TaxRate=tax;
               this.Amount=ItemPrice * 1;       
              let Amount=this.Amount * Quantity;
            var itemprice=Amount*Quantity*TaxRate/100
             Amount=Amount+itemprice;
             let ItemId=Id
             let ItemDescription=description;
            //  let TaxAmount =this.TaxAmount;
            let TaxAmount  =Math.round(itemprice * 100) / 100;
            var TotalNetItemAmount=Math.round(Amount * 100) / 100;
            var DisCountAmount=0;
             this.newAttribute = {ItemName,ItemPrice,Amount,Quantity,Id,ItemId,ItemDescription,TaxAmount,ItemCategory,TotalNetItemAmount,DisCountAmount};  
              this.myItems.push(this.newAttribute); 
             this.Bill=Amount+this.Bill;
             this.Bill=Math.round( this.Bill * 100) / 100;
  }
  }  
  decrementchoc(Quantity,Amount,ItemPrice,ItemCategory,taxrate){
    if(Quantity>1)
    {
    Quantity =Quantity-1;
    for (var i= 0; i <this.myItems.length; i++) { 
      var  test = this.myItems[i];
    
      if(ItemCategory==test.ItemName)
      {
          var taxAmt =this.TaxAmount;  
          let qty=1;   
          this.Amount=ItemPrice * 1;       
         let Amount=this.Amount * qty;
          var itemprice=this.myItems[i].TaxAmount/ this.myItems[i].Quantity;
            test.Quantity=Quantity;
             this.Bill=this.Bill-itemprice-ItemPrice;
               test.Amount=this.myItems[i].Amount-itemprice-ItemPrice;
               this.myItems[i].TotalNetItemAmount=  test.Amount;
               this.myItems[i].TaxAmount=this.myItems[i].TaxAmount-itemprice;
               this.myItems[i].Quantity=Quantity;

               if(this.DAmount>0)
               {
                this.TBill=this.TBill-itemprice-ItemPrice;
               }
               this.myItems[i].TotalNetItemAmount= Math.round(this.myItems[i].TotalNetItemAmount * 100) / 100;
               this.myItems[i].TaxAmount= Math.round(this.myItems[i].TaxAmount * 100) / 100;
               this.Bill=Math.round( this.Bill * 100) / 100;

      }
    }
    }
  }

  incrementchoc(Quantity,Amount,ItemPrice,ItemName,taxrate){

    Quantity =Quantity+1;
    this.Price=ItemPrice;
    for (var i= 0; i <this.myItems.length; i++) { 
    var  test = this.myItems[i];
      if(ItemName==test.ItemName)
      {
        // if(this.TaxAmount==undefined)
        // {
        //   var taxAmt =taxrate;  
        //   // let TaxRate1=tax1;
        //   let qty=1;   
        //   this.Amount=ItemPrice * 1;       
        //  let Amount=this.Amount * qty;
        //   // var itemprice=Amount*qty*taxAmt/100;
        //   var itemprice=this.myItems[i].TaxAmount/ this.myItems[i].Quantity;
        // }
        // else{
          var taxAmt =this.TaxAmount;  
          // let TaxRate1=tax1;
          let qty=1;   
          this.Amount=ItemPrice * 1;       
         let Amount=this.Amount * qty;
         var itemprice=this.myItems[i].TaxAmount/ this.myItems[i].Quantity;
        // }
      
        // var itemprice=ItemPrice*1*taxrate/100;
        this.Bill=this.Bill+itemprice+ItemPrice;
        test.Amount=this.myItems[i].Amount+itemprice+ItemPrice;
        this.myItems[i].TotalNetItemAmount=  test.Amount;
        this.myItems[i].TaxAmount=itemprice+this.myItems[i].TaxAmount;
        this.myItems[i].Quantity=Quantity;
           if(this.DAmount>0)
           {
            this.TBill=this.TBill+itemprice+ItemPrice;
           }
        this.myItems[i].TotalNetItemAmount= Math.round(this.myItems[i].TotalNetItemAmount * 100) / 100;
        this.myItems[i].TaxAmount= Math.round(this.myItems[i].TaxAmount * 100) / 100;
        this.Bill=Math.round( this.Bill * 100) / 100;
           
      }
    }
  }
  // billcalaculation(ItemCategory,Id)
  // {  
  // let a=0;
  //   let bill=this.Bill;
  //   if(bill==0)
  //   {
  //     this.Bill=20+13.2;
  //   }
  //   for (var i= 0; i <this.myItems.length; i++) {     
  //       if(this.myItems[i].ItemCategory==ItemCategory)
  //       {
        
  //         this.Bill=this.Bill+this.myItems[i].ItemPrice;
  //       } 
       
  //  }
  
  // }


  onChange()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.CustomerID.value;
      form.merchantKeyId = params["merchantKeyId"];
      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      form.PosSubscriptionId = merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCustomerIDDetail(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result==null)
      {
        this.isemployee=false;
      }
      else{
       var cid=this.CustomerID.value;
       var rid=result.customerId;
       if(cid==rid)
       {
            this.isemployee=true;
       }
      
      }
    });
 
  }

  onChangeid()
  {
    let form = { merchantKeyId: "", Email:"", PosSubscriptionId:"" ,MobileNumber:""};
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.Email = this.Email.value;
      form.MobileNumber=this.MobileNo.value;
      form.merchantKeyId = params["merchantKeyId"];   
      form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetCustomerid(form).subscribe(result => {   
      if(result!=null)
      {
        // this.rows=result;
        this.cname=result.CustomerName;
        this.cmobileno=result.MobileNo;
        this.cemail=result.Email;
        this.cAddress=result.Address;
        this.cBirthDay=result.BirthDay;
        this.cNotes=result.Notes;
        this.cContactPerference=result.ContactPerference;
        this.cid=result.CustomerId;
      }
      else{
        this.newcustomercreate=true;
      }
    });
  }

  deleteitem(rowid,itemId,Quantity,Amount,ItemPrice,ItemCategory)
  {
    if (rowid !== -1) {
      // this.isbillcalculate=false;
      this.Bill=this.Bill-Amount;
      this.myItems.splice(rowid, 1);
    } 
  if(rowid == 0) 
  {
    if(this.myItems.length==0)
    {
      this.Applycouponscode=false;
      this.isbillcalculate=false;
      this.couponcode=false;
      if(this.updateorderid !=null)
      {
        this.openConfirmationDialog();
      }
    }
   
  }

  }


  
   

    showhideminamount()
    {
     
     var address= this.isBillingaddress;
      if(this.isBillingaddress==true)
      {
       this.billingaddressdeatil=true
      }
      else{
        this.billingaddressdeatil = false;
      }
    }
    showhideisShipping()
    {
      if(this.customerdetails==true)
      {
       this.shippingaddress=true;
       this.customerdetails=false;
      }
      else{
        this.show = !this.show;
        if(this.show)  
        this.shippingaddress=true;
        else
        this.shippingaddress=false;
      }
    }

   


    CustomerDetailshide()
    {
     if(this.shippingaddress==true)
     {
      this.customerdetails=true;
      this.shippingaddress=false;
     }
      // this.shippingaddress=false;
      else{
        this.show = !this.show;
        if(this.show)  
        this.customerdetails=true;
        else
        this.customerdetails=false;
      }

    }
    NewOrderCreationWithCash()
    {
      this.paymenttype="Cash"
      this.cashpay=true;
      this.SendEmail=false;
    }
    NewOrderCreationWithEmail()
    {
      this.Customermail=this.Email.value;
      if(this.Customermail ==null)
      {
        this.Customermail=this.MobileNo.value;
      }

      this.SendEmail=true;
      this.cashpay=false;
      this.paymenttype="Email"
    }
    amountcal()
    {
        var tenderamount=this.tenderamount.value;   
       var totbill=this.Bill;
      //  this.rtnamount=tenderamount-totbill;
      //  if(this.rtnamount < 0)   
      //  {
      //    this.invalidamount=true;
      //  }
      //  else{
      //   this.invalidamount=false;
      //  }
    }
    cash()
    {
      let form = {
     
        PosSubscriptionId:"",
        OrderId:"",
        OrderAmount :"",
        TenderAmount :"",
        ReturnAmount :"",
      }
      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      form.PosSubscriptionId = merchantdata.PosSubscriptionId;

      form.OrderId =this.oid;
      form.OrderAmount=this.Bill.toString();
      form.TenderAmount = this.tenderamount.value
      form.ReturnAmount =  this.rtnamount;
       this.service.CashPayment(form).subscribe(result => {
         if(result!=null)
         {
          swal("Order ID:" + this.oid, "Order created successfully", "success");
          this.router.navigate(["/pos"]);
         }
       
      });
    }
    NewOrderCreation() {
      let form = {
        UserId:this.commonfunction.getUserId(),
        DiscountAmount:"",
     Id:0,
      PosSubscriptionId:"",
      OrderId:"",
      TenderType:"",
  AddressLine1:"",
  AddressLine2 :"",
  City :"",
  State :"",
  ZipCode :"",
  Country :"",
  Email1 :"",
   Email2:"",
  Phone1:"",
  Phone2 :"" ,
  ShippingAmount:"",
  TaxAmount:"",
  myitems:"",
  OrderDetails: [],
  Description:"",
  TotalNetAmount:"",
  ItemId:"",
  Amount:"",
  ItemName:"",
   OrderType :"",
  Email :"",
  Phone :"",
  OrderSource:"",
  
  Customer:{
    CustomerId:"",
     CustomerName  :"",
      Email  :"",
      MobileNo  :"",
      BirthDay  :"",
      Notes  :"",
      ContactPerference  :"",
  },
  BillingAddress:
  {
    AddressLine1:"",
  AddressLine2 :"",
  City :"",
  State :"",
  ZipCode :"",
  Country :"",
  Email1 :"",
   Email2:"",
  Phone1:"",
  Phone2 :"",
  },
  ShippingAddress:
  {
  AddressLine1:"",
  AddressLine2 :"",
  City :"",
  State :"",
  ZipCode :"",
  Country :"",
  Email1 :"",
  Email2:"",
  Phone1:"",
  Phone2 :"",

  },
  
  
  
      };
      form.DiscountAmount=this.discountAmount;
      form.OrderSource="POSWeb"
     form.Id=this.orderdetailsid;
      form.Customer.CustomerId=this.CustomerID.value;
      form.Customer.CustomerName = this.CustomerName.value;
      form.Customer.Email = this.Email.value;
      form.Customer.MobileNo = this.MobileNo.value;
      form.Customer.Email = this.Email.value;
      // form.Customer.Address = this.Address.value;
      form.Customer.BirthDay=this.BirthDay.value;
      form.Customer.Notes=this.Notes.value;
      form.Customer.ContactPerference=this.ContactPerference.value;
  // alert(form.Customer.ContactPerference);
      form.BillingAddress.AddressLine1 = this.Address1.value;
      form.BillingAddress.AddressLine2 = this.Address2.value;
      form.BillingAddress.City = this.City.value;
      form.BillingAddress.State = this.State.value;
      form.BillingAddress.ZipCode = this.ZipCode.value;
      form.BillingAddress.Country=this.Country.value;
      form.BillingAddress.Email1=this.ShippingEmail.value;
      form.BillingAddress.Phone1=this.MobileNumber.value;
      form.ShippingAddress.AddressLine1 = this.Address1.value;
      form.ShippingAddress.AddressLine2 = this.Address2.value;
      form.ShippingAddress.City = this.City.value;
      form.ShippingAddress.State = this.State.value;
      form.ShippingAddress.ZipCode = this.ZipCode.value;
      form.ShippingAddress.Country=this.Country.value;
      form.ShippingAddress.Email1=this.ShippingEmail.value;
      form.ShippingAddress.Phone1=this.MobileNumber.value;
      form.TotalNetAmount=this.Bill.toString();
      form.Amount=this.Amount;
     if(this.Email.value !=null || this.Email.value !="")
     {
       form.Email=this.Email.value;
     }
      form.OrderId=this.updateorderid;
      if(form.OrderId==null || form.OrderId=="" || form.OrderId ==undefined)
    {
      form.OrderId=uuid.v4().substring(0,6);
      //alert(form.OrderId)
    }
      if(this.mail.value !="")
      {
        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (filter.test(this.mail.value)) {
          form.OrderType="Email";
          form.Email=this.mail.value; 

        }
        else{
          form.Phone=this.mail.value;
          // form.OrderType="Mobile";
          form.OrderType="Mobile";
        }

      }
      // form.ShippingAmount="20";
      // form.TaxAmount="13.5"; 
       form.OrderDetails=this.myItems;

      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      form.PosSubscriptionId = merchantdata.PosSubscriptionId;

      this.service.NewOrder(form).subscribe(result => {
        console.log(" result - ", result);
        if (result != null) {
          if(result.OrderId !=null)
          { 
            localStorage.removeItem('Orderslist');
            this.oid=result.OrderId
            if(this.paymenttype=="Cash")
            {
              this.cash()
            }
       
          }        
          if(this.paymenttype !="Cash")
          {
            swal("Order ID:" + this.oid, "Order created successfully", "success");
            this.router.navigate(["/pos"]);
          }
          
          
        }
      });
     }
  

    createcustomer() {
      let form = {
        PosSubscriptionId:"",
      CustomerId :"",
      CustomerName  :"",
      Email  :"",
      MobileNo  :"",
      Address  :"",
      BirthDay  :"",
      BusinessName  :"",
      Notes  :"",
      ContactPerference  :""
      };
      form.CustomerId = this.CustomerID.value;
      form.CustomerName = this.CustomerName.value;
      form.Email = this.Email.value;
      form.MobileNo = this.MobileNo.value;
      form.Email = this.Email.value;
      form.Address = this.Address.value;
      form.BirthDay=this.BirthDay.value;
      // form.BusinessName=this.BusinessName.value;
     // form.BusinessName=this.BusinessName.value;
      form.Notes=this.Notes.value;
      form.ContactPerference=this.ContactPerference.value;
  
      let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
      form.PosSubscriptionId = merchantdata.PosSubscriptionId;
      // alert(this.requestDate.value);
      // alert(this.dueDate.value);
      this.service.AddCustomer(form).subscribe(result => {
      //  console.log(" result - ", result);
        // if (result != null) {
        //   swal("Added", "Customer Added Successfully", "success");  
        //   this.router.navigate(["/pos/customer/manage"]);
        // }
      });
  
         }
  



    tenderamounterror()
    {
      return this.tenderamount.hasError("required") ? "Amount  is required"
         : "";
    }
    
    Emailmobilenumber()
    {
      return this.mail.hasError("required") ? "Email or Mobile number  is required"
         : "";
    }

    customerEmailAddress()
    {
      return this.Email.hasError("pattern") ? "Please enter email address in correct Format" : "";
  
    }
    shippingEmailError()
    {
      return this.ShippingEmail.hasError("pattern") ? "Please enter email address in correct Format" : "";
  
    }
    shippingMobileNumberError()
    {
      return this.MobileNumber.hasError("pattern") ? "Phone Number should be numeric" : "";
    }
    mobileNoError()
    {
      return this.MobileNo.hasError("pattern") ? "Phone Number should be numeric" : "";
    }





    checkcouponcode() {
      // let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      // var posId= merchantdata.PosSubscriptionId;
    // var Mid=posId.split('PIN')[1];
    // var code=this.Ccode.value;
     this.Totalcost=this.Bill;


    let form = {
      DiscountAmount:"",
   Id:0,
    PosSubscriptionId:"",
    OrderId:"",
    TenderType:"",
AddressLine1:"",
AddressLine2 :"",
City :"",
State :"",
ZipCode :"",
Country :"",
Email1 :"",
 Email2:"",
Phone1:"",
Phone2 :"" ,
ShippingAmount:"",
TaxAmount:"",
//myitems:"",
OrderDetails: [],
Description:"",
TotalNetAmount:"",
ItemId:"",
Amount:"",
ItemName:"",
 OrderType :"",
Email :"",
Phone :"",
OrderSource:"",

Customer:{
  CustomerId:"",
   CustomerName  :"",
    Email  :"",
    MobileNo  :"",
    Address  :"",
    BirthDay  :"",
    Notes  :"",
    ContactPerference  :"",
},
BillingAddress:
{
  AddressLine1:"",
AddressLine2 :"",
City :"",
State :"",
ZipCode :"",
Country :"",
Email1 :"",
 Email2:"",
Phone1:"",
Phone2 :"",
},
ShippingAddress:
{
AddressLine1:"",
AddressLine2 :"",
City :"",
State :"",
ZipCode :"",
Country :"",
Email1 :"",
Email2:"",
Phone1:"",
Phone2 :"",

},



    };
    form.DiscountAmount=this.discountAmount;
    form.OrderSource="POSWeb"
   form.Id=this.orderdetailsid;
    form.Customer.CustomerId=this.CustomerID.value;
    form.Customer.CustomerName = this.CustomerName.value;
    form.Customer.Email = this.Email.value;
    form.Customer.MobileNo = this.MobileNo.value;
    form.Customer.Email = this.Email.value;
    // form.Customer.Address = this.Address.value;
    form.Customer.BirthDay=this.BirthDay.value;
    form.Customer.Notes=this.Notes.value;
    form.Customer.ContactPerference=this.ContactPerference.value;
// alert(form.Customer.ContactPerference);
    form.BillingAddress.AddressLine1 = this.Address1.value;
    form.BillingAddress.AddressLine2 = this.Address2.value;
    form.BillingAddress.City = this.City.value;
    form.BillingAddress.State = this.State.value;
    form.BillingAddress.ZipCode = this.ZipCode.value;
    form.BillingAddress.Country=this.Country.value;
    form.BillingAddress.Email1=this.ShippingEmail.value;
    form.BillingAddress.Phone1=this.MobileNumber.value;
    form.ShippingAddress.AddressLine1 = this.Address1.value;
    form.ShippingAddress.AddressLine2 = this.Address2.value;
    form.ShippingAddress.City = this.City.value;
    form.ShippingAddress.State = this.State.value;
    form.ShippingAddress.ZipCode = this.ZipCode.value;
    form.ShippingAddress.Country=this.Country.value;
    form.ShippingAddress.Email1=this.ShippingEmail.value;
    form.ShippingAddress.Phone1=this.MobileNumber.value;
    form.TotalNetAmount=this.Bill.toString();
    form.Amount=this.Amount;
   if(this.Email.value !=null || this.Email.value !="")
   {
     form.Email=this.Email.value;
   }
    form.OrderId=this.updateorderid;
    if(form.OrderId==null && form.OrderId=="" && form.OrderId ==undefined)
    {
      form.OrderId=uuid.v4().substring(0,6);
      //alert(form.OrderId)
    }
    if(this.mail.value !="")
    {
      var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (filter.test(this.mail.value)) {
        form.OrderType="Email";
        form.Email=this.mail.value; 

      }
      else{
        form.Phone=this.mail.value;
        // form.OrderType="Mobile";
        form.OrderType="Mobile";
      }

    }
    // form.ShippingAmount="20";
    // form.TaxAmount="13.5"; 
     form.OrderDetails=this.myItems;

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;







  this.service.getCoupondetails(form,this.Ccode.value).subscribe(result => {
    if(result!=null)
    {
      var tAmount=this.Bill;
      this.Bill=result.TotalNetAmount;
      if(result.DiscountAmount>0)
      {
        this.removecoupons=true;
       this.Applycouponscode=false;
        this.invalidcouponmsg=false;
        this.btncoupon=true;
        this.discountAmount=result.DiscountAmount;
        this.DAmount=result.DiscountAmount;
        if(tAmount==this.DAmount)
        {
          this.TBill=1;
        }
        else
        {
          this.TBill=this.Bill-result.DiscountAmount;
        }
        this.discAmount=true;
       for(let i=0;i<this.myItems.length;i++)
       {
          this.myItems[i].DisCountAmount=result.OrderDetails[i].DisCountAmount;
          // this.myItems[i].Amount=result.orderDetails[i].totalNetItemAmount;
       }
      }
      else{
        this.removecoupons=false;
        this.Applycouponscode=true;
        this.invalidcouponmsg=true;
        this.TBill=this.Bill-result.DiscountAmount;
        this.discAmount=false;
      }
     
    }
 
    // if(result.discountAmount>0)
    // {
    //   this.invalidcouponmsg=false;
    //   this.btncoupon=true;
    //   this.Bill=this.Bill-result.discountAmount;
    //   if(this.Bill<=0)
    //   {
    //     this.Bill=1;
    //   }
    //   this.discountAmount=result.discountAmount
    // }
    // else
    // {
    //   this.invalidcouponmsg=true;
    //   if(this.discountAmount>0)
    //   {
    //     this.Bill=this.Bill+this.discountAmount;
    //   }
      
    // }
  });

    }


    Removecouponcode()
    {
    this.Applycouponscode=true;
    this.removecoupons=false;
      if(this.discountAmount>0)
      {
        this.discAmount=false;
         if(this.Totalcost!=this.discountAmount)
         {
          this.Bill=this.Bill;
         }
         else{
          this.Bill=this.discountAmount;
         }
     
        this.discountAmount=0;
        this.btncoupon=false;
      }
     
    }
    Applycoupon()
    {
      this.discAmount=false;
      this.btncoupon=false;
      if(this.discountAmount>0)
      {
        this.Bill=this.DAmount+this.TBill;
        this.discountAmount=0;


      }
      else
      {
       this.invalidcouponmsg=false;
      }
    }


    Applycouponcode()
    {
      this.Applycouponscode=true;
    }

    Getzipcodedetails() {
      this.businessinfo.Zipcodedetails(this.ZipCode.value).subscribe(result => {
        if (result != null) {
          this.city = result.CityVillageArea;
          this.state = result.State;
          var pincode = this.state.toLowerCase().split(' ');
          for (var i = 0; i < pincode.length; i++) {
            pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
          }
          pincode = pincode.filter(item => item !== '');
        this.State = pincode.join(' ');;
          this.country = result.Country;
        }
        else {
          this.city = "";
          this.state = "";
          this.country = "";
        }
      });
    }
}

